import React from 'react'
import { Box } from '../../Box'
import { Required } from '../../Required'
import { Typography } from '../../Typography'
import { StyledPageFooter } from './PageFooterTemplate.styles'
import type { PageFooterTemplateProps } from './PageFooterTemplate.types'

export const PageFooterTemplate = React.forwardRef<
  HTMLElement,
  PageFooterTemplateProps
>(({ actions, notation, required, ...props }, ref) => (
  <StyledPageFooter ref={ref} data-core-react="page-footer-template" {...props}>
    <Box display="flex" flexDirection="column" gap="xs">
      {required && (
        <Required showLabel>
          {typeof required === 'string' ? required : null}
        </Required>
      )}

      {notation && (
        <Typography color="gray15" intent="small">
          {notation}
        </Typography>
      )}
    </Box>

    <Box display="flex" gap="sm">
      {actions}
    </Box>
  </StyledPageFooter>
))
